import type { ReactNode } from 'react';

import { Box, IconButton, styled } from '@mui/material';

import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

import { CloseIcon, SettingsIcon } from '@libs/shared/ui/icons';

import { actionPanelHeight } from './action-panel-height';

const OptionsContainer = styled(Box)`
  background: ${Colors.white};
  height: calc(100% - ${actionPanelHeight});
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
  gap: ${Spacing.small};
  padding-bottom: ${Spacing.small};
`;

const StyledIconButton = styled(IconButton)`
  position: relative;

  &:before {
    position: absolute;
    height: calc(100% + 16px);
    content: '';
    left: -5px;
    border-left: 1px solid ${Colors.darkGrey};
  }

  &:after {
    position: absolute;
    height: 5px;
    content: '';
    top: -10px;
    width: 200%;
    left: -20px;
    transform: translateX(calc(25% + 1px));
    background: ${Colors.white};
  }
`;

type Props = {
  disabled: boolean;
  children?: ReactNode;
  open: boolean;
  toggle: () => void;
};

export const SettingsMenu = ({ disabled, children, open, toggle }: Readonly<Props>) => {
  if (open) {
    return (
      <>
        <OptionsContainer>{children}</OptionsContainer>
        <StyledIconButton size="small" onClick={toggle} disabled={disabled}>
          <CloseIcon style={{ zIndex: 2 }} />
        </StyledIconButton>
      </>
    );
  }

  return (
    <IconButton sx={{ color: Colors.darkGrey }} size="small" onClick={toggle} disabled={disabled}>
      <SettingsIcon />
    </IconButton>
  );
};
